(function ($, _) {
  'use strict'

  // Establish the root object ('window' in the browser)
  const root = this

  /**
	 *
	 * @param {string} text
	 * @returns {string}
	 */
  root.nl2br = function nl2br(text) {
    return (String(text)).replace(/([^\n\r>]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2')
  }
}).call(this, jQuery, _)
